import { Injectable } from '@angular/core';
import { Rotas } from '@core/enums/routes';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import { Observable } from 'rxjs';
import { DataPrimeiraColetaPCD } from '../submodulos/monitoramento/pages/estacoes-automaticas/data-primeira-coleta-pcd';

@Injectable({
	providedIn: 'root',
})
export class PCDService {
	constructor(private httpClient: HttpClientProtectedService) {}

	buscarDatasPrimeirasColetasPCDs(): Observable<DataPrimeiraColetaPCD[]> {
		return this.httpClient.get(
			Rotas.ACOMPANHAMENTO_COLETA + '/datas-primeiras-coletas-pcds'
		);
	}
}
